import React, { useMemo, useState } from "react";
import { useAuth } from "../auth"; // adjust path if needed

export default function LinkField({
  link = "",
  onChange, // (nextLink: string) => void
  basePath = "", // optional: "posts"
  canEdit = true,
}) {
  const [editing, setEditing] = useState(false);

  // ✅ get domain from subscription
  const { subscription } = useAuth();
  const accountDomain = subscription?.account?.domain || "";

  const href = useMemo(() => {
    const s = String(link || "").replace(/^\/+/, "");
    const bp = String(basePath || "")
      .trim()
      .replace(/^\/+/, "")
      .replace(/\/+$/, "");

    const domain = String(accountDomain || "")
      .trim()
      .replace(/^https?:\/\//, "")
      .replace(/\/+$/, "");

    const path = [bp, s].filter(Boolean).join("/");

    // fallback if domain not loaded yet
    if (!domain) return `/${path}`.replace(/\/{2,}/g, "/");

    return `https://${domain}/${path}`.replace(/\/{2,}/g, "/");
  }, [link, basePath, accountDomain]);

  return !editing ? (
    <div style={{ marginTop: 8, marginBottom: 14 }}>
      <div
        style={{
          padding: "10px 12px",
          border: "1px solid #ccc",
          borderRadius: 8,
          background: "#fafafa",
          display: "flex",
          alignItems: "center",
          gap: 12,
          minHeight: 42,
        }}
      >
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#2563eb", textDecoration: "underline" }}
        >
          {href}
        </a>

        {canEdit && (
          <button
            type="button"
            onClick={() => setEditing(true)}
            style={{
              fontSize: 12,
              padding: "2px 6px",
              borderRadius: 4,
              border: "1px solid #ccc",
              background: "#fff",
            }}
          >
            Edit
          </button>
        )}
      </div>
    </div>
  ) : (
    <input
      style={{
        width: "100%",
        padding: 10,
        borderRadius: 8,
        border: "1px solid #ccc",
      }}
      type="text"
      value={link || ""}
      onChange={(e) => onChange?.(e.target.value)}
      onBlur={() => setEditing(false)}
      autoFocus
    />
  );
}
